import { useEffect, useState } from 'react';

export const useWindowDimensions = () => {
  const [dimension, setDimension] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const debounceResizerHandler = debounce(() => {
      setDimension([window.innerWidth, window.innerHeight]);
    }, 100);
    window.addEventListener('resize', debounceResizerHandler);
    return () => {
      window.removeEventListener('resize', debounceResizerHandler);
    };
  }, []);

  return dimension;
};

function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      //eslint-disable-next-line
      fn.apply(this, arguments);
    }, ms);
  };
}
